import moment from "moment-timezone";
export const getDailyTurnover = ({ITEMS_PER_PAGE, rentalsData, turnoverPage}) => {
    const today = moment().startOf("day");
    const pickups = rentalsData.filter(
        (rental) =>
        moment(rental.pickupDateTime).isSame(today, "day") &&
        rental.status !== "cancelled"
    );
    const returns = rentalsData.filter(
        (rental) =>
        moment(rental.returnDateTime).isSame(today, "day") &&
        rental.status !== "cancelled"
    );

    // Only paginate if ITEMS_PER_PAGE is reasonable (not trying to get all data)
    const shouldPaginate = ITEMS_PER_PAGE && ITEMS_PER_PAGE < 1000;
    
    let paginatedPickups, paginatedReturns;
    
    if (shouldPaginate) {
        // Paginate pickups and returns for display
        paginatedPickups = pickups.slice(
            (turnoverPage.pickups - 1) * ITEMS_PER_PAGE,
            turnoverPage.pickups * ITEMS_PER_PAGE
        );
        paginatedReturns = returns.slice(
            (turnoverPage.returns - 1) * ITEMS_PER_PAGE,
            turnoverPage.returns * ITEMS_PER_PAGE
        );
    } else {
        // Return all data (for PDF generation or full display)
        paginatedPickups = pickups;
        paginatedReturns = returns;
    }

    return {
        pickups: paginatedPickups,
        returns: paginatedReturns,
        totalPickups: pickups.length,
        totalReturns: returns.length,
    };
};